import { render, staticRenderFns } from "./ModalEditarFormSanitario.vue?vue&type=template&id=210c90e6&scoped=true&"
import script from "./ModalEditarFormSanitario.vue?vue&type=script&lang=js&"
export * from "./ModalEditarFormSanitario.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarFormSanitario.vue?vue&type=style&index=0&id=210c90e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c90e6",
  null
  
)

export default component.exports